import {
    GET_INCIDENT_REPORTS,
    GET_INCIDENT_REPORTS_SUCCESS,
    GET_INCIDENT_REPORTS_FAILURE,
    SET_INCIDENT_REPORT_FILTERS,
    RESET_INCIDENT_REPORT_FILTERS
} from './types';

export const getIncidentReports = orgId => ({
    type: GET_INCIDENT_REPORTS,
    payload: { orgId }
});

export const getIncidentReportsSuccess = reports => ({
    type: GET_INCIDENT_REPORTS_SUCCESS,
    payload: reports
});

export const getIncidentReportsFailure = error => ({
    type: GET_INCIDENT_REPORTS_FAILURE,
    payload: error
});

// Severity/category/status/review_stage/violation/guard/location/property/date filters —
// plain, synchronous UI state, held in the reducer (mirrors Rentals) so the panel never
// re-subscribes the live listener on a filter change.
export const setIncidentReportFilters = filters => ({
    type: SET_INCIDENT_REPORT_FILTERS,
    payload: filters
});

export const resetIncidentReportFilters = () => ({
    type: RESET_INCIDENT_REPORT_FILTERS
});
